// Skills mock data
export const skillsMockData = [
  {
    id: "skill-1",
    name: "CustomerLookup",
    description: "Retrieves customer information from the database based on various search criteria",
    parameters: [
      {
        name: "email",
        type: "STRING",
        required: false,
        description: "Customer's email address"
      },
      {
        name: "phoneNumber",
        type: "STRING",
        required: false,
        description: "Customer's phone number"
      },
      {
        name: "customerId",
        type: "STRING",
        required: false,
        description: "Unique identifier for the customer"
      }
    ],
    returns: {
      type: "OBJECT",
      description: "Customer information including contact details, purchase history, and preferences"
    }
  },
  {
    id: "skill-2",
    name: "ProductSearch",
    description: "Searches the product catalog based on various criteria",
    parameters: [
      {
        name: "query",
        type: "STRING",
        required: true,
        description: "Search query text"
      },
      {
        name: "category",
        type: "STRING",
        required: false,
        description: "Product category to filter by"
      },
      {
        name: "priceRange",
        type: "OBJECT",
        required: false,
        description: "Price range with min and max values"
      },
      {
        name: "inStock",
        type: "BOOLEAN",
        required: false,
        description: "Filter for products in stock"
      }
    ],
    returns: {
      type: "ARRAY",
      description: "List of matching products with details like name, price, and availability"
    }
  },
  {
    id: "skill-3",
    name: "OrderTracker",
    description: "Retrieves order status and tracking information",
    parameters: [
      {
        name: "orderId",
        type: "STRING",
        required: true,
        description: "Unique order identifier"
      }
    ],
    returns: {
      type: "OBJECT",
      description: "Order status, estimated delivery, and tracking details"
    }
  },
  {
    id: "skill-4",
    name: "SustainabilityScore",
    description: "Calculates the sustainability score for a product or order",
    parameters: [
      {
        name: "productId",
        type: "STRING",
        required: false,
        description: "Product identifier to score"
      },
      {
        name: "orderId",
        type: "STRING",
        required: false,
        description: "Order identifier to score all products"
      }
    ],
    returns: {
      type: "OBJECT",
      description: "Sustainability metrics including carbon footprint, recyclability, and eco-score"
    }
  },
  {
    id: "skill-5",
    name: "AppointmentScheduler",
    description: "Books appointments for services like assembly, planning, or consultation",
    parameters: [
      {
        name: "serviceType",
        type: "STRING",
        required: true,
        description: "Type of service to book"
      },
      {
        name: "customerId",
        type: "STRING",
        required: true,
        description: "Customer identifier"
      },
      {
        name: "preferredDate",
        type: "STRING",
        required: false,
        description: "Preferred date for appointment"
      },
      {
        name: "preferredTimeSlot",
        type: "STRING",
        required: false,
        description: "Preferred time slot"
      }
    ],
    returns: {
      type: "OBJECT",
      description: "Appointment details including confirmation number, date, time, and location"
    }
  },
  {
    id: "skill-6",
    name: "ProductRecommendation",
    description: "Recommends products based on customer preferences and purchase history",
    parameters: [
      {
        name: "customerId",
        type: "STRING",
        required: false,
        description: "Customer identifier for personalized recommendations"
      },
      {
        name: "productId",
        type: "STRING",
        required: false,
        description: "Product identifier for related recommendations"
      },
      {
        name: "room",
        type: "STRING",
        required: false,
        description: "Room type for targeted recommendations"
      },
      {
        name: "budget",
        type: "NUMBER",
        required: false,
        description: "Budget constraint for recommendations"
      }
    ],
    returns: {
      type: "ARRAY",
      description: "List of recommended products with relevance scores and justifications"
    }
  },
  {
    id: "skill-7",
    name: "StoreInventoryChecker",
    description: "Checks real-time inventory levels at physical stores",
    parameters: [
      {
        name: "productId",
        type: "STRING",
        required: true,
        description: "Product identifier"
      },
      {
        name: "storeId",
        type: "STRING",
        required: false,
        description: "Specific store to check"
      },
      {
        name: "zipCode",
        type: "STRING",
        required: false,
        description: "ZIP code to find nearby stores"
      },
      {
        name: "radius",
        type: "NUMBER",
        required: false,
        description: "Search radius in miles"
      }
    ],
    returns: {
      type: "ARRAY",
      description: "List of stores with inventory levels, distances, and availability dates"
    }
  },
  {
    id: "skill-8",
    name: "ReturnProcessor",
    description: "Processes product return requests and generates return labels",
    parameters: [
      {
        name: "orderId",
        type: "STRING",
        required: true,
        description: "Order identifier"
      },
      {
        name: "productIds",
        type: "ARRAY",
        required: true,
        description: "List of product identifiers to return"
      },
      {
        name: "returnReason",
        type: "STRING",
        required: true,
        description: "Reason for return"
      },
      {
        name: "returnMethod",
        type: "STRING",
        required: true,
        description: "Preferred return method (mail, store drop-off)"
      }
    ],
    returns: {
      type: "OBJECT",
      description: "Return confirmation, return label URL, and refund information"
    }
  },
  {
    id: "skill-9",
    name: "AssemblyInstructionFinder",
    description: "Retrieves assembly instructions and provides step guidance",
    parameters: [
      {
        name: "productId",
        type: "STRING",
        required: true,
        description: "Product identifier"
      },
      {
        name: "language",
        type: "STRING",
        required: false,
        description: "Preferred language for instructions"
      },
      {
        name: "step",
        type: "NUMBER",
        required: false,
        description: "Specific assembly step to retrieve"
      }
    ],
    returns: {
      type: "OBJECT",
      description: "Assembly instructions with text, images, videos, and troubleshooting tips"
    }
  },
  {
    id: "skill-10",
    name: "SentimentAnalyzer",
    description: "Analyzes customer sentiment from conversation context",
    parameters: [
      {
        name: "conversationId",
        type: "STRING",
        required: false,
        description: "Conversation identifier"
      },
      {
        name: "text",
        type: "STRING",
        required: false,
        description: "Text to analyze directly"
      }
    ],
    returns: {
      type: "OBJECT",
      description: "Sentiment scores, emotion detection, intent recognition, and suggested actions"
    }
  }
];